module.exports = __webpack_public_path__ + "static/blind-soprano-shoots-for-the-moon-4b43ef53ef5e383b15ee3024d6d2792d.jpg";